import Vue from "vue"

const InputOnlyNumber = {
  bind: el => {
    // el.addEventListener("paste", ev => ev.preventDefault())
    el.addEventListener("keypress", ev => {
      const key = ev.key
      if (!(key >= "0" && key <= "9") && key !== ".") {
        ev.preventDefault()
      }
      
      const input = ev.target
      if (
        input.value != null &&
        (String(input.value).split(".") || []).length > 1 &&
        key === "."
      ) {
        ev.preventDefault()
      }
      //
      // if (
      //   input.value != null &&
      //   input.value.startsWith("0")
      // ) {
      //   ev.preventDefault()
      // }
      if (
        input.value != null &&
        input.value.indexOf(".") > -1 &&
        key === "."
      ) {
        ev.preventDefault()
      }
      
      // if (
      //   input.value != null &&
      //   input.value.indexOf(".") > -1 &&
      //   (input.value.split('.')[1].length > 1)
      // ) {
      //   ev.preventDefault()
      // }
    })
  }
}

const InputOnlyInt = {
  bind: el => {
    el.addEventListener("keypress", ev => {
      const key = ev.key
      if (!(key >= "0" && key <= "9")) {
        ev.preventDefault()
      }
    })
  }
}

Vue.directive("only-number", InputOnlyNumber)
Vue.directive("only-int", InputOnlyInt)